export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_MODAL = 'SHOW_MODAL'

export const showModal = (modalType) => {
  return dispatch => dispatch({
    type: SHOW_MODAL,
    modalType: modalType
  })
}

export const hideModal = () => dispatch => {
  dispatch({
    type: HIDE_MODAL
  })
}



// WEBPACK FOOTER //
// ./src/actions/modal.js